import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
var gScale = 1

function setCalcuStr () {
  const data = arguments[0]
  let json = Object.keys(data).sort()
  let newData = {}
  var signStr = ''
  for (let i = 0; i < json.length; i++) {
    newData[json[i]] = data[json[i]]
  }
  for (const key in newData) {
    signStr += newData[key] + key
  }
  signStr += 'SGFKKSL2392XF022MDBK9308B'
  return signStr
}
// (0, eval)(function (p, a, c, k, e, d) {
//   e = function (c) {
//     return c.toString(36)
//   }
//   if (!''.replace(/^/, String)) {
//     while (c--) {
//       d[c.toString(a)] = k[c] || c.toString(a)
//     }
//     k = [function (e) {
//       return d[e]
//     }]
//     e = function () {
//       return '\\w+'
//     }
//     c = 1
//   }
//   while (c--) {
//     if (k[c]) {
//       p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c])
//     }
//   }
//   return p
// }('f h(){8 5=b[0];4 3=d.a(5).9();4 2={};c 1="";7(4 i=0;i<3.e;i++){2[3[i]]=5[3[i]]}7(8 6 j 2){1+=2[6]+6}1+="g";k 1}', 21, 21, '|signStr|newData|json|let|data|key|for|let|sort|keys|arguments|let|Object|length|function|SGFKKSL2392XF022MDBK9308B|setCalcuStr||in|return'.split('|'), 0, {}))

function setCalcuMd5Str (params) {
  return md5(setCalcuStr(params)).toUpperCase()
}

function inExtList (str, extList) {
  if (!extList) {
    return false
  }
  for (var i = 0; i < extList.length; i++) {
    if (str === extList[i]) {
      return true
    }
  }
  return false
}

export function Params (that, options, extList) {
  this.fm = that.$store.state.urlData.fm
  this.appKey = that.$store.state.urlData.appKey
  this.v = that.$store.state.urlData.v
  if (options) {
    for (var k in options) {
      if (!inExtList(k, extList)) {
        this[k] = options[k]
      }
    }
  }
  this.sign = setCalcuMd5Str(this)
  if (options) {
    for (let k in options) {
      if (inExtList(k, extList)) {
        this[k] = options[k]
      }
    }
  }
  // this.sessionid = getSessionId()
  this.actH5Token = getSessionId()
}

export let loading = function () {}
// loading.show = function () {
//   let node1 = document.createElement('div')
//   node1.setAttribute('class', 'loading-component')
//   let node2 = document.createElement('div')
//   node2.setAttribute('class', 'loading-box')
//   let nodeSpan = []
//   for (let i = 1; i <= 6; i++) {
//     nodeSpan[i] = document.createElement('span')
//     nodeSpan[i].setAttribute('class', 'loading-item loading-item' + i)
//     node2.appendChild(nodeSpan[i])
//   }
//   node1.appendChild(node2)
//   document.body.appendChild(node1)
// }
// loading.hide = function () {
//   let loadStr = document.getElementsByClassName('loading-component')[0]
//   document.body.removeChild(loadStr)
// }
loading.show = function () {
  let node1 = document.createElement('div')
  node1.setAttribute('class', 'loading-component')
  let node2 = document.createElement('div')
  node2.setAttribute('class', 'loading-box')
  let nodeSpan = []
  for (let i = 1; i <= 3; i++) {
    nodeSpan[i] = document.createElement('span')
    nodeSpan[i].setAttribute('class', 'loading-item loading-item' + i)
    node2.appendChild(nodeSpan[i])
  }
  node1.appendChild(node2)
  document.body.appendChild(node1)
}
loading.hide = function () {
  let loadStr = document.getElementsByClassName('loading-component')[0]
  document.body.removeChild(loadStr)
}

// 获取cookie
export function getCookie (name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return (arr[2])
  } else {
    return null
  }
}

// 设置cookie,增加到vue实例方便全局调用
export function setCookie (cName, value, exdate) {
  document.cookie = cName + '=' + escape(value) + ((exdate == null) ? '' : ';expires=' + (exdate ? exdate.toGMTString() : '0'))
}
export function setSessionId (sessionId) {
  // var exdate = new Date()
  // exdate.setTime(exdate.getTime() + 10 * 24 * 60 * 60 * 1000)
  setCookie('sessionActId', sessionId)
}

export function setUid (uid) {
  setCookie('setUid', uid)
}
export function getUid () {
  var uid = getCookie('setUid')
  return uid === null ? '' : uid
}

export function getSessionId () {
  var sessionId = getCookie('sessionActId')
  return sessionId === null ? 'c54a713f0419b5b9b9383c71006feeb1ab7004ef0624883284ffed5bbcf966ff20e87167296acec657c97d0fce2cd3a9926956cd1793de87' : sessionId
}
// 删除cookie
export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}
export function getComputeSize (size) {
  if (size <= 1024) {
    return '<1K'
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(1) + 'K'
  } else {
    return (size / (1024 * 1024)).toFixed(1) + 'M'
  }
}

export function getDateFormat (time) {
  if (!time) {
    return ''
  }
  var date = new Date(time)
  return date.getFullYear() +
    '-' + ((date.getMonth() + 1 + '').length === 1 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + '') +
    '-' + ((date.getDate() + '').length === 1 ? '0' + date.getDate() : date.getDate() + '') +
    ' ' + ((date.getHours() + '').length === 1 ? '0' + date.getHours() : date.getHours() + '') +
    ':' + ((date.getMinutes() + '').length === 1 ? '0' + date.getMinutes() : date.getMinutes() + '')
}
export const browser = {
  versions: (function () {
    let u = navigator.userAgent
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
      androidChrome: u.match(/Chrome\/([\d.]+)/), // android chrome
      iosChrome: u.match(/CriOS\/([\d.]+)/), // ios chrome
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      safari: u.indexOf('Safari') > -1 && u.indexOf('Chrome') < 1, // 是否safari
      weixin: u.indexOf('MicroMessenger') > -1, // 是否微信
      qq: u.indexOf('QQ') > -1 // 是否QQ
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
export const encryptDes = function (message, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}
export const decryptDes = function (ciphertext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(ciphertext)
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export function resizeRem () {
  var winWidth = 0
  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if (document.body && document.body.clientWidth) {
    winWidth = document.body.clientWidth
  }

  if (winWidth > 750) {
    winWidth = 750
  }
  gScale = winWidth / 375
  var fontSize = winWidth / 3.75
  document.querySelector('html').style.fontSize = fontSize + 'px'
}

// 获取链接参数
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.href.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}



// WEBPACK FOOTER //
// ./src/util/util.js